import React, { memo } from "react"
import Link from "next/link"
import CardLiveShow from "components/CardLiveShow"
// import DisplayTypeScreenBlock from "utils/DisplayTypeScreenBlock"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"
import { Navigation } from "swiper"

// eslint-disable-next-line react/display-name
const SwiperChannel = memo(({ name, events, id }) => {
  return (
    <div className="mb-4 md:mb-4 lg:mb-6 ">
      <h2 className="relative mb-2 md:mb-2 text-sm md:text-lg lg:text-xl font-semibold ">
        <Link href={`/danh-muc/${id}`}>
          <div className="text-dark-100 flex items-center wapper_see_more">
            <span className="uppercase mr-4">{name}</span>{" "}
            <div className="text-primary-500 text-sm flex items-center see_more">
              <span>Xem thêm</span>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13 17L18 12L13 7"
                  stroke="#66A7FF"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 17L11 12L6 7"
                  stroke="#66A7FF"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        </Link>
      </h2>
      <div className="relative wapper__swiper__custom">
        <Swiper
          key={"liveshow"}
          slidesPerView={4.8}
          slidesPerGroup={4}
          spaceBetween={16}
          modules={[Navigation]}
          className="swiper__channel"
          navigation={true}
          breakpoints={{
            1: {
              slidesPerView: 1.8,
              slidesPerGroup: 1
            },
            768: {
              slidesPerView: 3.25,
              slidesPerGroup: 3
            },
            890: {
              slidesPerView: 3.8,
              slidesPerGroup: 3
            },
            1050: {
              slidesPerView: 4.2,
              slidesPerGroup: 4
            },
            1280: {
              slidesPerView: 4.8,
              slidesPerGroup: 4
            }
          }}
        >
          {events?.length > 0 &&
            events?.map((item) => {
              const { id } = item
              item.thumbnail_horizontal = item.thumbnail
              return (
                <SwiperSlide key={id}>
                  <CardLiveShow {...item} isChannel={true} showTime={false} />
                </SwiperSlide>
              )
            })}
        </Swiper>
      </div>
    </div>
  )
})

export default SwiperChannel
